import React, { useCallback, useEffect, useState } from 'react';
import Toggle from '../../../../components/Toggle/Toggle';
import cx from 'classnames';
import styles from './TableItem.module.scss';
import { useTranslation } from 'react-i18next';

export const TableItem = ({ action, changeSetting, isEnabled }) => {
  const [toggle, setToggle] = useState(action.value);
  const { t } = useTranslation();

  useEffect(() => {
    setToggle(action.value);
  }, [action]);

  const undoSetting = () => {
    setToggle(prevState => !prevState);
  };

  const clickToggle = useCallback(
    e => {
      e.stopPropagation();
      if (!isEnabled) {
        return;
      }

      setToggle(prev => {
        const toggled = !prev;
        const settings = [
          {
            id: action.id,
            medium: action.medium,
            enabled: toggled,
          },
        ];
        changeSetting(settings, undoSetting);
        return toggled;
      });
    },
    [isEnabled, changeSetting, undoSetting]
  );

  return (
    <div className={cx(styles.engagementSwitchContainer)}>
      <span>{t(action.label)}</span>
      <Toggle
        id={action.id}
        className={cx(!isEnabled && styles.disabledToggle)}
        checked={toggle}
        onChange={clickToggle}
        size="medium"
        disabled={!isEnabled}
      />
    </div>
  );
};
